'use client';

import type { CollectionCardProps } from './types';

import { CollectionCardSheetContent } from '~/components/collection-card/collection-card-sheet-content';
import { Sheet, SheetContent, SheetTrigger } from '~/components/ui';
import { BaseCard } from '../base-card';
import { getRarityName } from './utils';

export const CollectionCard = ({
  label,
  rarity,
  imageSrc,
  imagePosition,
  title,
  brandName,
  className,
  id,
  dropChance,
  ...props
}: CollectionCardProps) => {
  const badgeText = dropChance ? `${Math.round(dropChance * 100)}%` : getRarityName(rarity);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <BaseCard
          badgeText={badgeText}
          brandName={brandName}
          className={className}
          imagePosition={imagePosition}
          imageSrc={imageSrc ?? null}
          label={label}
          rarity={rarity}
          title={title}
          {...props}
        />
      </SheetTrigger>
      <SheetContent className="rounded-t-3xl pb-10">
        <CollectionCardSheetContent brandName={brandName} collectionId={id} rarity={rarity} title={title} />
      </SheetContent>
    </Sheet>
  );
};
